// third party
import * as yup from 'yup';

// project imports
import { SCHEDULE_TYPES } from 'store/app/admin/alarm';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        priority: yup.string().nullable(),
        alarmScheduleType: yup
            .string()
            .oneOf(SCHEDULE_TYPES, intl.formatMessage({ id: 'ui-comp-formvalidation-fielddatatype-unexpectedvalue' }))
            .nullable(),
        alarmStartDayOffset: yup.number().nullable(),
        alarmEndDayOffset: yup.number().nullable(),
        metadata: yup
            .object()
            .shape({
                transitions: yup
                    .array()
                    .of(
                        yup
                            .object()
                            .shape({
                                transition: yup.string().nullable(),
                                canBeExecutedManually: yup.boolean().nullable(),
                                executeParentTransitions: yup.array().of(yup.string()).nullable(),
                                parentStatesRequired: yup.array().of(yup.string()).nullable(),
                                parentStatesForbidden: yup.array().of(yup.string()).nullable()
                            })
                            .nullable()
                    )
                    .nullable()
            })
            .nullable()
    });

export default validationSchema;
